export default __webpack_public_path__ + "static/media/Kannada_politics_m.9cbb2b4f.wav";